import React, { useEffect, useState } from 'react';
import { hot } from 'react-hot-loader/root';
import { ThemeProvider } from 'styled-components';
import { generateTheme } from '@cld/theme-helper';
import GlobalStyle from '@cld/global-style';
import getEnvConfig from '@cld/env-config';
import theme from './theme';
import { ConfigContext } from './context/ConfigContext';
import { scriptLoader } from './services/ScriptLoader';
import { PresetsContainer } from './components/PresetsContainer';
import { AppWrapper } from './App.styled';
import { parsePresets } from './utils';

const App = () => {
    const [config, setConfig] = useState(null);
    const [presets, setPresets] = useState(null);

    useEffect(() => {
        const { scriptUrl } = getEnvConfig();
        scriptLoader(scriptUrl, 'custom-action-script').then(() => {
            Promise.all([
                    window.cloudinary.customAction.getConfig(),
                    window.cloudinary.customAction.getItems({ itemType: 'transformation' }),
                ],
            )
                .then((results) => {
                    const [configData, presetsData] = results;
                    const config = configData.config ? configData.config : configData;
                    setConfig({ ...config });
                    setPresets(parsePresets(presetsData.response));
                })
                .catch((e) => console.log('error fetching data', e));
        });
    }, []);

    return (
        <ThemeProvider theme={generateTheme(theme)}>
            <>
                <GlobalStyle />
                <ConfigContext.Provider value={config}>
                    <AppWrapper>
                        <PresetsContainer presets={presets} config={config} />
                    </AppWrapper>
                </ConfigContext.Provider>
            </>
        </ThemeProvider>
    );
};

export default hot(App);
